import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SetPopupReducerData } from "../../../store/reducer/PopupReducer";
import CustomTable from "../../../ui/custom-table";
import { useNavigate } from "react-router-dom";
import {
  deleteStudentData,
  GetStudents,
  StatusChangeStudent,
} from "../../../api/api";
import { toast } from "react-toastify";
import { FaEdit } from "react-icons/fa";

function Student() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [student, setStudent] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [totalRows, setTotalRows] = useState(0);
  const { showModal } = useSelector(
    (state) => state?.PopupReducer?.modal || {}
  );
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const { user_id, organization_id } = useSelector(
    (state) => state?.authUser?.data?.data
  );

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 500); // Debounce by 500ms

    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  const fetchStudent = async () => {
    setLoading(true);
    try {
      const page = pagination.pageIndex + 1;
      const limit = pagination.pageSize;
      const search = debouncedSearch;
      let data;
      if (debouncedSearch)
        data = await GetStudents(page, limit, search, user_id, organization_id);
      else
        data = await GetStudents(page, limit, search, user_id, organization_id);

      if (data?.data?.status === true) {
        setStudent(data?.data?.data || []);
        setTotalRows(data?.data?.total_records || 0);
      }
    } catch (error) {
      //console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStudent();
  }, [pagination, debouncedSearch]);

  useEffect(() => {
    if (showModal === false) {
      fetchStudent();
    }
  }, [showModal]);

  const columns = useMemo(
    () => [
      { accessorKey: "name", header: "Name" },
      {
        accessorKey: "images",
        header: "Image",
        Cell: ({ row }) => {
          const imagePath = row.original.images[0];
          const imageUrl = imagePath
            ? `https://visionemptrack.greymatterz.com/${imagePath}`
            : "";

          return (
            imageUrl && (
              <img
                src={imageUrl}
                alt="Employee"
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            )
          );
        },
      },
      { accessorKey: "enrollment_no", header: "Enrollment No." },
      { accessorKey: "email", header: "Email" },
      { accessorKey: "roll_no", header: "Roll no." },
      { accessorKey: "course_name", header: "Course Name" },
      { accessorKey: "year_semester", header: "Year& Semester" },

      {
        accessorKey: "Status",
        header: "Status",
        Cell: ({ row }) => {
          const isActive = row.original.is_blocked;

          return (
            <div className="d-flex align-items-center gap-2">
              <label className="custom-toggle mb-0">
                <input
                  type="checkbox"
                  checked={isActive}
                  onChange={() => handleStausChange(row.original._id, isActive)}
                />
                <span className="slider"></span>
              </label>
              <span
                className={`fw-bold ${
                  isActive ? "text-success" : "text-danger"
                }`}
              >
                {isActive ? "UnBlock" : "Block"}
              </span>
            </div>
          );
        },
      },
    ],
    []
  );

  const handleStausChange = async (id, status) => {
    console.log("id", id);
    let payload = {
      is_blocked: status === true ? false : true,
      user_id,
      organization_id,
      student_id: id,
    };
    try {
      const data = await StatusChangeStudent(payload);
      if (data) {
        fetchStudent();
      }
    } catch (error) {}
  };

  const handleAddClick = () => {
    navigate("/add-user");
  };

  const handleEdit = (row) => {
    navigate(`/edit-student/${row._id}`);
  };

  const handelDelete = async (row) => {
    const data = await deleteStudentData(row._id, user_id, organization_id);
    if (data) {
      toast("Record deleted successfully");
      fetchStudent();
    }
  };

  return (
    <CustomTable
      columns={columns}
      data={student}
      loading={loading}
      showActions={true}
      onAddClick={handleAddClick}
      addButtonLabel="Create New"
      onEdit={handleEdit}
      onDelete={handelDelete}
      pagination={pagination}
      onPaginationChange={(updater) => {
        setPagination((prev) => {
          const newPagination =
            typeof updater === "function"
              ? updater(prev)
              : { ...prev, ...updater };
          return newPagination;
        });
      }}
      rowCount={totalRows}
      onSearchChange={(e) => {
        setSearchTerm(e.target.value);
        setPagination({ pageIndex: 0, pageSize: 10 }); // Reset pagination on search
      }}
    />
  );
}

export default Student;
